const isMac = window.navigator.userAgent.indexOf('Mac') > -1

const keys = {
  login: isMac ? 'command+b' : 'ctrl+b',
  personLogin: isMac ? 'command+shift+b' : 'ctrl+shift+b',
  tabChange: (id) => `${id + 1}`,
  searchInput: '/',
  down: 'down',
  up: 'up',
  search: isMac ? 'command+k' : 'ctrl+k',
  escape: 'esc',
  openEdit: isMac ? 'command+e' : 'ctrl+e',
  saveEdit: isMac ? 'command+s' : 'ctrl+s',
}

export default keys
